import React from 'react';
import { FaRocket } from 'react-icons/fa';
import Modal from '../common/Modal';

const UpgradeInfoModal = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="升級系統說明" size="md">
      <div className="space-y-6">
        {/* 升級系統 */}
        <section className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl p-6 border-2 border-amber-300">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 bg-gradient-to-br from-amber-500 to-orange-500 rounded-full flex items-center justify-center shadow-md">
              <FaRocket className="text-white text-xl" />
            </div>
            <h3 className="text-2xl font-bold text-amber-700">
              等級與速度
            </h3>
          </div>

          <div className="space-y-4">
            {/* 速度等級系統 */}
            <div className="bg-white/90 rounded-xl p-4">
              <h4 className="font-bold text-lg text-amber-700 mb-3">
                ⚡ 5階段進化
              </h4>
              <div className="space-y-2 text-sm">
                
                {/* Level 1 */}
                <div className="flex justify-between items-center p-3 bg-gradient-to-r from-blue-50 to-blue-100 rounded-lg border-l-4 border-blue-500">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white font-bold text-xs">
                      Lv.1
                    </div>
                    <div>
                      <div className="font-bold text-blue-800 text-base">起步</div>
                      <div className="text-xs text-blue-600">基礎速度</div>
                    </div>
                  </div>
                  <span className="font-mono font-bold text-blue-400">0 pts</span>
                </div>

                {/* Level 2 */}
                <div className="flex justify-between items-center p-3 bg-gradient-to-r from-green-50 to-green-100 rounded-lg border-l-4 border-green-500">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-green-500 flex items-center justify-center text-white font-bold text-xs">
                      Lv.2
                    </div>
                    <div>
                      <div className="font-bold text-green-800 text-base">衝刺</div>
                      <div className="text-xs text-green-600">速度提升</div>
                    </div>
                  </div>
                  <span className="font-mono font-bold text-green-500">100 pts</span>
                </div>

                {/* Level 3 */}
                <div className="flex justify-between items-center p-3 bg-gradient-to-r from-cyan-50 to-cyan-100 rounded-lg border-l-4 border-cyan-500">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-cyan-500 flex items-center justify-center text-white font-bold text-xs">
                      Lv.3
                    </div>
                    <div>
                      <div className="font-bold text-cyan-800 text-base">疾風</div>
                      <div className="text-xs text-cyan-600">泡泡變多</div>
                    </div>
                  </div>
                  <span className="font-mono font-bold text-cyan-500">350 pts</span>
                </div>

                {/* Level 4 */}
                <div className="flex justify-between items-center p-3 bg-gradient-to-r from-purple-50 to-purple-100 rounded-lg border-l-4 border-purple-500">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-purple-500 flex items-center justify-center text-white font-bold text-xs">
                      Lv.4
                    </div>
                    <div>
                      <div className="font-bold text-purple-800 text-base">閃電</div>
                      <div className="text-xs text-purple-600">挑戰極限</div>
                    </div>
                  </div>
                  <span className="font-mono font-bold text-purple-500">750 pts</span>
                </div>

                {/* Level 5 */}
                <div className="flex justify-between items-center p-3 bg-gradient-to-r from-red-50 to-red-100 rounded-lg border-l-4 border-red-500">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-red-500 flex items-center justify-center text-white font-bold text-xs">
                      Lv.5
                    </div>
                    <div>
                      <div className="font-bold text-red-800 text-base">光速</div>
                      <div className="text-xs text-red-600">神之領域</div>
                    </div>
                  </div>
                  <span className="font-mono font-bold text-red-500">1450 pts</span>
                </div>

              </div>
            </div>

            {/* 獎勵說明 */}
            <div className="bg-orange-50 rounded-xl p-4 border border-orange-100">
               <p className="text-sm text-orange-800 text-center">
                 每升一級，泡泡生成速度與數量都會大幅提升！<br/>
                 善用<strong>連擊 (Combo)</strong> 快速累積高分吧！
               </p>
            </div>
          </div>
        </section>
      </div>
    </Modal>
  );
};

export default UpgradeInfoModal;